























import { Component, Vue, Prop } from "vue-property-decorator";
import VServiceTaskTableRowHeader from "./VServiceTaskTableRowHeader.vue";

@Component({
  components: {
    VServiceTaskTableRowHeader
  }
})
export default class VServiceTaskTable extends Vue {
  @Prop({ required: true }) rows!: number;
  get onMobile() {
    return this.$store.getters.onMobile;
  }
  screenWidth_03: number = (window.innerWidth - 20) * 0.3;
  screenWidth_06: number = (window.innerWidth - 20) * 0.7;

  handleResize() {
    this.screenWidth_03 = (window.innerWidth - 20) * 0.3;
    this.screenWidth_06 = (window.innerWidth - 20) * 0.7;
  }

  mounted() {
    window.addEventListener("resize", this.handleResize);
  }
}
